import crud from "./crud";

const path = "production_loss_categories";
const struct = {
  name: "",
  label: "",
  color: "#ff0000",
};
const generic = crud(path, struct);

const state = { ...generic.state };
const getters = { ...generic.getters };
const mutations = { ...generic.mutations };
const actions = { ...generic.actions };

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
